if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.announcement');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.index = 0;
      this.length = this.content.length;
      this.autoplayDelay = 4500;
      this.autoplayTimer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if ( this.nextButton ) {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled');
        this.nextButton.addEventListener('click', ()=>{
          this.changeSlide('next');
          this.restartAutoplay();
        });
      }
      if ( this.prevButton ) {
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled');
        this.prevButton.addEventListener('click', ()=>{
          this.changeSlide('prev');
          this.restartAutoplay();
        });
      }

      this.addEventListener('mouseenter', ()=> this.stopAutoplay());
      this.addEventListener('mouseleave', ()=> this.startAutoplay());
      this.addEventListener('focusin', ()=> this.stopAutoplay());
      this.addEventListener('focusout', ()=> this.startAutoplay());

      this.handleVisibilityChange = ()=>{
        if ( document.hidden ) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      };

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.startAutoplay();

    }

    disconnectedCallback() {
      this.stopAutoplay();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    startAutoplay() {
      if ( this.length < 2 || this.reducedMotion.matches || document.hidden || this.autoplayTimer ) return;
      this.autoplayTimer = window.setInterval(()=>{
        this.changeSlide('next');
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if ( ! this.autoplayTimer ) return;
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }

    changeSlide(direction) {

      if ( this.length < 2 ) return;

      if ( direction == 'next' ) {
        this.index = (this.index + 1) % this.length;
      } else if ( direction == 'prev' ) {
        this.index = (this.index - 1 + this.length) % this.length;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });

    }

  }

  if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}